<template>
    <button :type="nativeType" :disabled="loading" class="btn" @click="onClick" :class="{
    [`btn-${type}`]: true,
    'btn-block': block,
    'btn-lg': large,
    'btn-loading': loading
  }">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'v-button',

        props: {
            type: {
                type: String,
                default: 'primary'
            },

            nativeType: {
                type: String,
                default: 'submit'
            },

            loading: {
                type: Boolean,
                default: false
            },

            block: Boolean,
            large: Boolean
        },

        methods: {
            /**
             * @desc Обработка события нажатия на кнопку
             **/
            onClick() {
                this.$emit('click', arguments);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Button.vue